export const ELEVATION_NOISE_THRESHOLD_METERS = 3;
export const SMOOTHING_WINDOW_POINTS = 5;

export function toRadians(value) {
  return value * Math.PI / 180;
}

export function haversine(a, b) {
  const earthRadiusKm = 6371;
  const dLat = toRadians(b.latitude - a.latitude);
  const dLon = toRadians(b.longitude - a.longitude);
  const lat1 = toRadians(a.latitude);
  const lat2 = toRadians(b.latitude);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) ** 2;
  return 2 * earthRadiusKm * Math.asin(Math.sqrt(h));
}

export function getTicks(min, max, count) {
  const ticks = [];
  const step = (max - min) / Math.max(count - 1, 1);
  for (let index = 0; index < count; index += 1) {
    ticks.push(min + step * index);
  }
  return ticks;
}

export function thinPoints(points, maxPoints) {
  if (points.length <= maxPoints) {
    return points;
  }

  const step = Math.ceil(points.length / maxPoints);
  const thinned = points.filter((_, index) => index % step === 0);
  thinned.push(points[points.length - 1]);
  return thinned;
}

export function parseCssPixels(value, fallback) {
  const parsed = Number.parseInt(value, 10);
  return Number.isFinite(parsed) && parsed >= 260 ? parsed : fallback;
}

export function formatElevation(value) {
  return `${Math.round(value || 0).toLocaleString()} m`;
}

export function formatDistance(value) {
  const rounded = Math.round((Number.isFinite(value) ? value : 0) * 10) / 10;
  return `${rounded.toFixed(1)} km`;
}

export function formatDistanceValue(value) {
  return Number.isInteger(value) ? String(value) : value.toFixed(1);
}

export function round(value) {
  return Math.round(value * 10) / 10;
}

export function roundCoordinate(value) {
  return Number(value).toFixed(7).replace(/0+$/, "").replace(/\.$/, "");
}

export function escapeXml(value) {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&apos;");
}

export function createDownloadUrl(text, type) {
  return URL.createObjectURL(new Blob([text], { type }));
}

export function debounce(fn, wait) {
  let timeout;
  return function (...args) {
    window.clearTimeout(timeout);
    timeout = window.setTimeout(() => fn.apply(this, args), wait);
  };
}
